import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.5607 6.06066L13.9393 3.43934C13.658 3.15804 13.2765 3 12.8787 3H4.5C3.67156 3 3 3.67156 3 4.5V15.5C3 16.3284 3.67156 17 4.5 17H15.5C16.3284 17 17 16.3284 17 15.5V7.12131C17 6.72349 16.842 6.34196 16.5607 6.06066V6.06066ZM10 15C8.89544 15 8 14.1046 8 13C8 11.8954 8.89544 11 10 11C11.1046 11 12 11.8954 12 13C12 14.1046 11.1046 15 10 15ZM13 5.48375V8.625C13 8.83209 12.8321 9 12.625 9H5.375C5.16791 9 5 8.83209 5 8.625V5.375C5 5.16791 5.16791 5 5.375 5H12.5162C12.6157 5 12.7111 5.0395 12.7814 5.10984L12.8902 5.21859C12.925 5.25341 12.9526 5.29475 12.9715 5.34024C12.9903 5.38574 13 5.4345 13 5.48375V5.48375Z",
		fill: "#0D2976"
	})
});
export default SvgSave;
